import { createContext } from 'react';

import type { MinMax } from '../../core/types/min-max.js';

export const MinMaxConfigContext = createContext<Partial<MinMax>>({});
